import Omy from "../Omy";
import { OmyConst } from "../OmyConst";

export default class OMouse {
    constructor() {
        Omy.game.renderer.plugins.interaction.on("pointerdown", this._pointIsDown, this);
        Omy.game.renderer.plugins.interaction.on("pointerup", this._pointIsUp, this);
        Omy.game.renderer.plugins.interaction.on("pointerupoutside", this._pointIsUp, this);
        Omy.game.renderer.plugins.interaction.on("pointerover", this._pointIsOver, this);
        Omy.game.renderer.plugins.interaction.on("pointerout", this._pointIsOut, this);

        // Omy.addUpdater(this._update, this);
        this._gameWidth = Omy.WIDTH;
        this._gameHeight = Omy.HEIGHT;
        this._isDownEvent = false;
        this._isOutGame = false;

        this._DOWN_EVENT = "down";
        this._UP_EVENT = "up";
        this._emit = new OmyConst.Emit();
    }

    /**     * @private     */
    _pointIsDown() {
        this._isDownEvent = true;
        this._emit.emit(this._DOWN_EVENT, this.mouseX, this.mouseY);
    }

    /**     * @private     */
    _pointIsUp() {
        this._isDownEvent = false;
        this._emit.emit(this._UP_EVENT, this.mouseX, this.mouseY);
    }

    /**     * @private     */
    _pointIsOver() {
        this._isOutGame = false;
    }

    /**     * @private     */
    _pointIsOut() {
        this._isOutGame = true;
    }

    /**     * @private     */
    _update() {
        let global = Omy.game.renderer.plugins.interaction.eventData.data.global;
        if (global.x > 0 && global.x < this._gameWidth) {
            if (global.y > 0 && global.y < this._gameHeight) {
                this._isOutGame = false;
            } else {
                this._isOutGame = true;
            }
        } else {
            this._isOutGame = true;
        }
    }

    get isDown() {
        return this._isDownEvent;
    }

    get mouseX() {
        return Omy.game.renderer.plugins.interaction.eventData.data.global.x;
    }

    get mouseY() {
        return Omy.game.renderer.plugins.interaction.eventData.data.global.y;
    }

    get outGame() {
        return this._isOutGame;
    }

    get isMouse() {
        return !Omy.game.renderer.plugins.interaction.supportsTouchEvents;
    }

    addDownMouse(onHandler, context) {
        this._emit.once(this._DOWN_EVENT, onHandler, context);
    }

    addDownHandler(onHandler, context, once = false) {
        if (once) {
            this._emit.once(this._DOWN_EVENT, onHandler, context);
        } else {
            this._emit.on(this._DOWN_EVENT, onHandler, context);
        }
    }

    removeDownMouse(onHandler, context) {
        this._emit.removeListener(this._DOWN_EVENT, onHandler, context);
    }

    addUpHandler(onHandler, context, once = false) {
        if (once) {
            this._emit.once(this._UP_EVENT, onHandler, context);
        } else {
            this._emit.on(this._UP_EVENT, onHandler, context);
        }
    }

    removeUpMouse(onHandler, context) {
        this._emit.removeListener(this._UP_EVENT, onHandler, context);
    }
}
